<template>
  <ProductDetailPageBase>
    <ProductDetailPageLayout>
      <template #header>
        <ContainerSkinnyBanner />
      </template>
      <template #breadcrumb>
        <ContainerBreadcrumb />
      </template>
      <template #out-of-stock>
        <ContainerOutOfStock />
      </template>
      <template #product-visuals>
        <ContainerGalleryNew />
      </template>
      <template #product-aside-content>
        TitleDesktop<br />
        TitleMobile<br />
        TitleMobileAtc<br />
        <ContainerFlashSalesSticker />
        <ContainerAdvertisedPayment />
        Reassurance Items <br />
        <ContainerVerifiedRefurbishedCarousel />
        <ContainerSellerComment />
        <ContainerSeller />
      </template>
      <template #content>
        <ContainerCheckpointsCarousel />
        CustomizationFunnel <br />
        Recommendations <br />
        <ContainerCmsSection :index="1" />
        <ContainerReviews />
        <ContainerCmsSection :index="2" />
        <ContainerSeoLinks />
        <ContainerCmsSection :index="3" />
        <ContainerCmsSection :index="4" />
        <ContainerSeoTechSpecs />
        <ContainerCmsSection :index="5" />
        <ContainerArticles />
        <AboutUs />
        <ContainerTrustList />
      </template>
    </ProductDetailPageLayout>
  </ProductDetailPageBase>
</template>

<script setup lang="ts">
import ContainerAdvertisedPayment from '~/scopes/product-core/components/ContainerAdvertisedPayment/ContainerAdvertisedPayment.vue'
import ContainerArticles from '~/scopes/product-core/components/ContainerArticles/ContainerArticles.vue'
import ContainerBreadcrumb from '~/scopes/product-core/components/ContainerBreadcrumb/ContainerBreadcrumb.vue'
import ContainerCheckpointsCarousel from '~/scopes/product-core/components/ContainerCheckpointsCarousel/ContainerCheckpointsCarousel.vue'
import ContainerCmsSection from '~/scopes/product-core/components/ContainerCmsSection/ContainerCmsSection.vue'
import ContainerFlashSalesSticker from '~/scopes/product-core/components/ContainerFlashSalesSticker/ContainerFlashSalesSticker.vue'
import ContainerGalleryNew from '~/scopes/product-core/components/ContainerGalleryNew/ContainerGalleryNew.vue'
import ContainerOutOfStock from '~/scopes/product-core/components/ContainerOutOfStock/ContainerOutOfStock.vue'
import ContainerReviews from '~/scopes/product-core/components/ContainerReviews/ContainerReviews.vue'
import ContainerSeller from '~/scopes/product-core/components/ContainerSeller/ContainerSeller.vue'
import ContainerSellerComment from '~/scopes/product-core/components/ContainerSellerComment/ContainerSellerComment.vue'
import ContainerSeoLinks from '~/scopes/product-core/components/ContainerSeoLinks/ContainerSeoLinks.vue'
import ContainerSeoTechSpecs from '~/scopes/product-core/components/ContainerSeoTechSpecs/ContainerSeoTechSpecs.vue'
import ContainerSkinnyBanner from '~/scopes/product-core/components/ContainerSkinnyBanner/ContainerSkinnyBanner.vue'
import ContainerTrustList from '~/scopes/product-core/components/ContainerTrustList/ContainerTrustList.vue'
import ContainerVerifiedRefurbishedCarousel from '~/scopes/product-core/components/ContainerVerifiedRefurbishedCarousel/ContainerVerifiedRefurbishedCarousel.vue'
import ProductDetailPageBase from '~/scopes/product-core/components/ProductDetailPageBase/ProductDetailPageBase.vue'
import ProductDetailPageLayout from '~/scopes/product-core/components/ProductDetailPageLayout/ProductDetailPageLayout.vue'
import AboutUs from '~/scopes/product-core/components/presentationals/AboutUs/AboutUs.vue'
</script>
